import type { StudentWorkbookPageProgress } from '@mathflat/domain/StudentWorkbook'
import { computed, makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

export class StudentWorkbookPage extends DTO {
  progressId: number
  status: StudentWorkbookPageProgress['status']
  readonly openDatetime?: Date
  readonly workbookPage: StudentWorkbookPageProgress['page']

  get pageNum() {
    return this.workbookPage.page
  }

  constructor(data: StudentWorkbookPageProgress) {
    super()
    this.progressId = data.progressId
    this.status = data.status
    this.workbookPage = data.page
    this.openDatetime = data.openDatetime ? new Date(data.openDatetime) : undefined

    makeObservable(this, { status: observable, pageId: computed, pageNum: computed })
  }

  get pageId() {
    return this.workbookPage.id
  }
}
